// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-footer {
  padding: 37px;
}

footer.footer-02 {
  font-family: "Poppins";
  padding: 40px 0;
  z-index: 99;
  border-top: 1px solid #f1f1f1;
  background: #fff;
}
footer.footer-02 .footer {
  position: relative;
  margin: 0 auto;
}
footer.footer-02 .blue-circle {
  position: absolute;
  width: 129px;
  height: 129px;
  bottom: 50px;
  right: 0px;
  border-radius: 50%;
  background: #dae9ff;
}
footer.footer-02 .ftco-footer-social li {
  list-style: none;
  margin: 0 10px 0 0;
  display: inline-block;
}
footer.footer-02 .ftco-footer-social .facebook a {
  background-color: #3b5998;
}
footer.footer-02 .ftco-footer-social .twitter a {
  background-color: #55acee;
}
footer.footer-02 .ftco-footer-social .linkedin a {
  background-color: #007ab9;
}
footer.footer-02 .ftco-footer-social a {
  height: 46px;
  width: 46px;
  display: block;
  border-radius: 50%;
  position: relative;
}
footer.footer-02 .ftco-footer-social a i {
  position: absolute;
  font-size: 20px;
  top: 50%;
  color: #fff;
  left: 50%;
  transform: translate(-50%, -50%);
}
footer.footer-02 .logo {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #000000;
}
footer.footer-02 .footer-heading {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #000000;
}
footer.footer-02 p {
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 160%;
  color: #565656;
}
footer.footer-02 .list-unstyled li a {
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 200%;
  color: #000000;
}
footer.footer-02 .copyright {
  border-top: 1px solid #f1f1f1;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 160%;
  color: #a4a4a4;
}

.container-footer {
  padding: 37px;
}

footer.footer-02 {
  font-family: "Poppins";
  padding: 0px 0;
  z-index: 99;
  border-top: 1px solid #f1f1f1;
  background: #fff;
}

.footer {
  position: relative;
  margin: 0 auto;
}

.blue-circle {
  position: absolute;
  width: 129px;
  height: 129px;
  bottom: 50px;
  right: 0px;
  border-radius: 50%;
  background: #dae9ff;
}

.col-margin {
  margin-left: 75px;
}

#id1 {
  list-style: none;
  margin: 0 10px 0 0;
  display: inline-block;
}

.electriva-symbol {
  font-family: Helvetica, sans-serif;
  font-size: 35px;
  line-height: 60px;
  font-weight: 600;
  color: #00d664;
}

@media (max-width: 768px) {
  .inbox {
    background-color: #ffffff;
    border-radius: 4px;
    padding: 0;
    margin: 0 0 20px;
  }
  .inbox div a {
    border-bottom: 1px solid #ccc;
    display: block;
    color: #555;
    font-size: 14px;
    padding: 10px 0;
  }
  .inbox div a:hover {
    color: #204687;
  }
  .inbox div a:first-child {
    padding-top: 0;
  }
  .inbox div a:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
  .inbox div .active {
    color: #204687;
  }
}
@media (min-width: 768px) {
  .inbox-right {
    width: calc(100% - 420px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,eAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;AACF;AAAE;EACE,kBAAA;EACA,cAAA;AAEJ;AAAE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AAEJ;AACI;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;AACN;AAEM;EACE,yBAAA;AAAR;AAIM;EACE,yBAAA;AAFR;AAMM;EACE,yBAAA;AAJR;AAOI;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AALN;AAOM;EACE,kBAAA;EACA,eAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EAGA,gCAAA;AALR;AASE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAPJ;AASE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAPJ;AASE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;AARJ;AAWI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;AAVN;AAaE;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAXJ;;AAcA;EACE,aAAA;AAXF;;AAcA;EACE,sBAAA;EACA,cAAA;EACA,WAAA;EACA,6BAAA;EACA,gBAAA;AAXF;;AAaA;EACE,kBAAA;EACA,cAAA;AAVF;;AAYA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AATF;;AAYA;EACE,iBAAA;AATF;;AAaA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;AAVF;;AAaA;EACE,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAVF;;AAcA;EACE;IACE,yBAAA;IACA,kBAAA;IACA,UAAA;IACA,gBAAA;EAXF;EAaI;IACE,6BAAA;IACA,cAAA;IACA,WAAA;IACA,eAAA;IACA,eAAA;EAXN;EAaM;IACE,cAAA;EAXR;EAaM;IACE,cAAA;EAXR;EAaM;IACE,iBAAA;IACA,mBAAA;EAXR;EAcI;IACE,cAAA;EAZN;AACF;AAgBA;EACE;IACE,yBAAA;EAdF;AACF","sourcesContent":[".container-footer {\n  padding: 37px;\n}\n\nfooter.footer-02 {\n  font-family: \"Poppins\";\n  padding: 40px 0;\n  z-index: 99;\n  border-top: 1px solid #f1f1f1;\n  background: #fff;\n  .footer {\n    position: relative;\n    margin: 0 auto;\n  }\n  .blue-circle {\n    position: absolute;\n    width: 129px;\n    height: 129px;\n    bottom: 50px;\n    right: 0px;\n    border-radius: 50%;\n    background: #dae9ff;\n  }\n  .ftco-footer-social {\n    li {\n      list-style: none;\n      margin: 0 10px 0 0;\n      display: inline-block;\n    }\n    .facebook {\n      a {\n        background-color: #3b5998;\n      }\n    }\n    .twitter {\n      a {\n        background-color: #55acee;\n      }\n    }\n    .linkedin {\n      a {\n        background-color: #007ab9;\n      }\n    }\n    a {\n      height: 46px;\n      width: 46px;\n      display: block;\n      border-radius: 50%;\n      position: relative;\n\n      i {\n        position: absolute;\n        font-size: 20px;\n        top: 50%;\n        color: #fff;\n        left: 50%;\n        -webkit-transform: translate(-50%, -50%);\n        -ms-transform: translate(-50%, -50%);\n        transform: translate(-50%, -50%);\n      }\n    }\n  }\n  .logo {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 24px;\n    line-height: 36px;\n    color: #000000;\n  }\n  .footer-heading {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 30px;\n    color: #000000;\n  }\n  p {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 160%;\n\n    color: #565656;\n  }\n  .list-unstyled {\n    li a {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 200%;\n\n      color: #000000;\n    }\n  }\n  .copyright {\n    border-top: 1px solid #f1f1f1;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 160%;\n    color: #a4a4a4;\n  }\n}\n.container-footer {\n  padding: 37px;\n}\n\nfooter.footer-02 {\n  font-family: \"Poppins\";\n  padding: 0px 0;\n  z-index: 99;\n  border-top: 1px solid #f1f1f1;\n  background: #fff;\n}\n.footer {\n  position: relative;\n  margin: 0 auto;\n}\n.blue-circle {\n  position: absolute;\n  width: 129px;\n  height: 129px;\n  bottom: 50px;\n  right: 0px;\n  border-radius: 50%;\n  background: #dae9ff;\n}\n\n.col-margin {\n  margin-left: 75px;\n}\n\n\n#id1 {\n  list-style: none;\n  margin: 0 10px 0 0;\n  display: inline-block;\n}\n\n.electriva-symbol {\n  font-family: Helvetica, sans-serif;\n  font-size: 35px;\n  line-height: 60px;\n  font-weight: 600;\n  color: #00d664;\n}\n\n\n@media (max-width: 768px) {\n  .inbox {\n    background-color: #ffffff;\n    border-radius: 4px;\n    padding: 0;\n    margin: 0 0 20px;\n    div {\n      a {\n        border-bottom: 1px solid #ccc;\n        display: block;\n        color: #555;\n        font-size: 14px;\n        padding: 10px 0;\n\n        &:hover {\n          color: #204687;\n        }\n        &:first-child {\n          padding-top: 0;\n        }\n        &:last-child {\n          padding-bottom: 0;\n          border-bottom: none;\n        }\n      }\n      .active {\n        color: #204687;\n      }\n    }\n  }\n}\n@media (min-width: 768px) {\n  .inbox-right {\n    width: calc(100% - 420px);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
